await import('/home/ript/ds_code/front-sign/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('/home/ript/ds_code/front-sign/src/.umi/umi.ts');
export default 1;